import React, { useEffect, useState } from "react"
import './style.css';
import { Link, useParams } from "react-router-dom";
import img from './soulogo.png'
// import img2 from './img/logo2.png'
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import config from "../config/config";
import { useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import userAction, { setApiToken, setUserInfo } from "../actions/userActions";
import { getUserData, getUserInfoData } from "../actions/userdata";
import { Col, Row } from "react-bootstrap";
import { displayErrorString, getSouData } from "../Utils/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LoadingSpinner from "../Components/LoadingSpinner";
import { TimeUtils, getUpdatedDateWithTimezone } from "../Utils/TimeUtils";
import moment from "moment/moment";

const SouDetail = (props) => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [checkOne, setCheckOne] = useState(true);
  const [checkTwo, setCheckTwo] = useState(true);
  const [checkThree, setCheckThree] = useState(true);
  const [checkFour, setCheckFour] = useState(true);
  const [checkFive, setCheckFive] = useState(true);
  const [checkSix, setCheckSix] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date())
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [data, setData] = useState('');
  const [errorData, setErrorData] = useState('');
  const [newStartDate, setNewStartDate] = useState(moment().format('YYYY-MM-DD'))
  const [newEndDate, setNewEndDate] = useState(moment().format('YYYY-MM-DD'))
  const [accepted, setAccepted] = useState(false);

  const id = useParams()
  const getSou = async (id) => {
    var res = await getSouData(id)
    if (res.status == 200) {
      setData(res.data)
      setAccepted(Boolean(res?.data?.sou_signed))
      let newSD = getUpdatedDateWithTimezone(res.data?.new_start_date, res.data?.selected_schedule, res.data?.TIMEZONE)
      setNewStartDate(newSD)

      let endSD = getUpdatedDateWithTimezone(res.data?.new_end_date, res.data?.selected_schedule, res.data?.TIMEZONE)
      setNewEndDate(endSD)
    }
    else if (res.status === 404) {
      setErrorData(res.message);
    }
  }
  useEffect(() => {
    getSou(id?.id)
  }, [])

  const acceptSou = async () => {
    if (checkOne && checkTwo && checkThree && checkFour && checkFive && checkSix) {
      if (name == "") {
        toast.error('Please provide your signature to proceed.')
      } else {
        setIsLoading(true)
        try {
          let path = config.siteUrl;
          var response_final = await axios.post(path + "/processes/accept-reject-sou", {
            status: 1,
            generated_hash: id?.id,
            sign: name,
            date: startDate
          }, {
            headers: { 'Accept': 'Application/json' },
          })
            .then(function (response) {
              toast.success('SOU Accepted Successfully.');
              //setTimeout(() => navigate(`/dashboard`), 3000);
            })
            .catch(function (error) {
              return null;
            });
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
          console.error(error);
        }
      }
    } else {
      toast.error('Please accept all acknowledgments.')
    }
  }

  const rejectSou = async () => {
    setIsLoading(true)
    try {
      let path = config.siteUrl;
      var response_final = await axios.post(path + "/processes/accept-reject-sou", {
        status: 2,
        generated_hash: id?.id,
        sign: name,
        date: startDate
      }, {
        headers: { 'Accept': 'Application/json' },
      })
        .then(function (response) {
          toast.success('SOU Rejected.')
          //setTimeout(() => navigate(`/dashboard`), 3000);
        })
        .catch(function (error) {
          return null;
        });
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.error(error);
    }
  }

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <ToastContainer
        position="top-center"
      />
      <div className="Login">
        <div className="top-row-head">
          <div className="log-text">
            Logout
          </div>
        </div>

        {accepted ?
          <div className='m-4 box2'>
            <div className=' w-100 box-in'>
              <p style={{ paddingTop: '8px', marginLeft: '10px' }}>Success!</p>
            </div>
            <div className='data'>
              This course has already been signed and accepted according to the scheduled time.
            </div>
          </div> :
          data ? <>
            <div className="low-row">
              <div>
                <img src={img} style={{ width: '100%' }} />
              </div>
              <div className="student-head">
                SECTION I: Student Information
              </div>
              <Row className="w-100 m-auto">
                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        First Name:
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input value={data?.FIRSTNAME}
                          readOnly
                          disabled
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Last Name:
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input value={data?.LASTNAME}
                          readOnly
                          disabled
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Email:
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input value={data?.HOME_EMAIL}
                          readOnly
                          disabled
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="info-head-2 mt-3">
                Based on your availability and training requirements, you have been placed in an eMentor course. By checking the boxes below, you are agreeing to the following schedule:
              </div>
              <Row className="w-100 m-auto">
                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Course Number:
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input value={data?.serialized_course_number}
                          readOnly
                          disabled
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Course Type:
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input value={data?.COURSETYPE}
                          readOnly
                          disabled
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Language:
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input value={data?.LANGUAGE}
                          readOnly
                          disabled
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Time Zone:
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input value={data?.TIMEZONE}
                          readOnly
                          disabled
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Start Date:
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input value={newStartDate}
                          readOnly
                          disabled
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        End Date:
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input value={
                          data?.new_end_date ? moment(newEndDate).format('MM/DD/YYYY') : data?.serialized_course_number ? data?.serialized_course_number.split('-')[1]?.startsWith('30')
                            ? moment(newStartDate).add(3, 'weeks').format('MM/DD/YYYY')
                            : moment(newStartDate).add(10, 'weeks').format('MM/DD/YYYY') : ''
                        }
                          readOnly
                          disabled
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Schedule:
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <textarea
                          value={TimeUtils(data?.selected_schedule, data?.TIMEZONE)}
                          readOnly
                          disabled
                          className="w-100"
                          style={{ resize: 'none' }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Course Duration
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input value={
                          data?.serialized_course_number ? data?.serialized_course_number.split('-')[1]?.startsWith('30')
                            ? 12
                            : 40 : 40 + " Hours"
                        }
                          readOnly
                          disabled
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="student-head">
                SECTION II: Student Acknowledgment
              </div>
              <label className="ack-check">
                <input type="checkbox"
                  defaultChecked={checkOne}
                  onChange={() => setCheckOne((state) => !state)}
                />
                I have read the LEAP Policy and understand the expectations related to my LEAP Level development and sustainment as well as the eMentor requirements, homework expectations, final scores, etc.
              </label>
              <label className="ack-check">
                <input type="checkbox"
                  defaultChecked={checkTwo}
                  onChange={() => setCheckTwo((state) => !state)}
                />
                I will make every effort to attend all classes. I understand I am required to attend the first class and complete the final summative assessment. Failure to meet this requirement will result in not receiving course credit/scores.
              </label>
              <label className="ack-check">
                <input type="checkbox"
                  defaultChecked={checkThree}
                  onChange={() => setCheckThree((state) => !state)}
                />
                I agree to attend 80% or more of the total classes (32 hours of a 40-hour course/10 hours of a 12-hour course). Failure to meet this requirement will result in not receiving course credit/scores.
              </label>
              <label className="ack-check">
                <input type="checkbox"
                  defaultChecked={checkFour}
                  onChange={() => setCheckFour((state) => !state)}
                />
                I will make every effort to complete the homework assigned after every session.
              </label>
              <label className="ack-check">
                <input type="checkbox"
                  defaultChecked={checkFive}
                  onChange={() => setCheckFive((state) => !state)}
                />
                I am not scheduled for a Language Intensive Training Event (LITE) or any other TDY that will conflict with this course.
              </label>
              <label className="ack-check">
                <input type="checkbox"
                  defaultChecked={checkSix}
                  onChange={() => setCheckSix((state) => !state)}
                />
                I understand that failure to complete the End of Course Survey will affect my ability to participate in future eMentor courses and LITEs.
              </label>
              <div className="note">
                NOTE: Upon submission, the AFCLC will commit funds to your eMentor training.
              </div>
              <Row className="w-100 m-auto">
                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Student Signature:<span>*</span>
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <input
                          placeholder="Enter you full name"
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value)
                          }}
                          className="w-100" />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="w-100 m-auto this-row">
                    <Col>
                      <div className="info-head">
                        Today's Date:<span>*</span>
                      </div>
                    </Col>
                    <Col>
                      <div className="sou">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormat="MM/dd/yyyy"
                          className="input w-100"
                          minDate={new Date()}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="display-end">
                <button id="submit" type="submit" className="btn mt-3 bg-success text-white"
                  onClick={acceptSou}

                >{("Accept Schedule")}</button>
                <button id="submit" type="submit" className="btn mt-3 bg-danger text-white"
                  onClick={rejectSou}

                >{("Reject Schedule")}</button>
              </div>
            </div>
          </> :
            <>
              <div className='m-4 box2'>
                <div className=' w-100 box-in'>
                  <p style={{ paddingTop: '8px', marginLeft: '10px' }}>Error!</p>
                </div>
                <div className='data'>
                  {errorData}
                </div>
              </div>
            </>}
      </div >
    </>
  )
}
// export default Login
export default SouDetail;


